<template>
  <CollapseTransition>
    <div v-if="isOpen"
         class="moderator-marketing-mailings-history__table-messages-wrap">
      <div class="moderator-marketing-mailings-history__table-messages">
        <template v-if="item.sms">
          <h4 class="moderator-marketing-mailings-history__table-messages-title">
            {{ getChangeLabel('sms') }}
          </h4>
          <div class="text">
            <p v-html="item.sms"></p>
          </div>
        </template>

        <template v-if="item.bot">
          <h4 class="moderator-marketing-mailings-history__table-messages-title">
            {{ getChangeLabel('bot') }}
          </h4>
          <div class="text">
            <p v-html="item.bot"></p>
          </div>
        </template>

        <template v-if="item.site">
          <h4 class="moderator-marketing-mailings-history__table-messages-title">
            {{ getChangeLabel('site') }}
          </h4>
          <div class="text">
            <p v-html="item.site"></p>
          </div>
        </template>

        <template v-if="item.email">
          <h4 class="moderator-marketing-mailings-history__table-messages-title">
            {{ getChangeLabel('email') }}
          </h4>
          <div v-html="item.email"
               class="text"></div>
        </template>
      </div>
    </div>
  </CollapseTransition>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'AMMarketingMailingsHistoryMessages',
    components: {
      CollapseTransition
    },
    props: {
      item: Object,
      isOpen: Boolean,
      getChangeLabel: Function
    }
  }
</script>

<style lang="less">

</style>
